
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  methods: {
    getRelativeUrl (image) {
      const { url } = image.image.data.attributes

      return url.replace(/^.*\/\/[^/]+/, '')
    }
  }
}
